import { IFavoriteInitial } from "./types";
import { defaultPagination } from "app/redux/initialState";

export const initialState: IFavoriteInitial = {
  loading: false,
  error: "",
  favorites: [],
  isSearching: false,
  searchValue: "",
  openModalId: null,
  pagination: {
    ...defaultPagination,
  },
  updateFavoriteLoading: false,
};
